import {
  GlassView,
  GlassViewProps,
  isLiquidGlassAvailable,
} from 'expo-glass-effect';
import { IsInGlassProvider, useIsInGlass } from 'hooks/isInGlass';
import { theme } from 'lib/theme';
import { StyleProp, View, ViewStyle } from 'react-native';

type Props = {
  children: React.ReactNode;
  glass?: boolean;
  style?: StyleProp<Omit<ViewStyle, 'backgroundColor'>>;
  backgroundColor?: string;
  tintColor?: GlassViewProps['tintColor'];
  isInteractive?: boolean;
  disabled?: boolean;
  boxShadowBlurRadius?: number;
};
export const Glass = ({
  children,
  style,
  glass = true,
  backgroundColor = theme.colors.white95,
  tintColor,
  isInteractive = true,
  disabled,
  boxShadowBlurRadius = 5,
}: Props) => {
  const isInGlass = useIsInGlass();
  const withGlass = !isInGlass && isLiquidGlassAvailable();

  if (!glass) {
    return <View style={style}>{children}</View>;
  }

  return (
    <IsInGlassProvider value={true}>
      {withGlass ? (
        <GlassView
          key={!isInteractive || disabled ? 'd' : 'a'}
          isInteractive={isInteractive && !disabled}
          style={style}
          tintColor={tintColor}
          colorScheme="light"
        >
          {children}
        </GlassView>
      ) : (
        <View
          style={[
            style,
            {
              backgroundColor: isInGlass ? undefined : backgroundColor,
              boxShadow:
                !glass || isInGlass
                  ? undefined
                  : [
                      {
                        offsetX: 0,
                        offsetY: 1,
                        blurRadius: `${boxShadowBlurRadius}px`,
                        spreadDistance: '0px',
                        color: theme.colors.black10,
                        inset: false,
                      },
                    ],
            },
            disabled ? { opacity: theme.opacityDisabled } : undefined,
          ]}
        >
          {children}
        </View>
      )}
    </IsInGlassProvider>
  );
};
